import React, { useEffect, useState } from "react";
import "../../assets/styles/local/AddMissingItems.css";
import { IoIosClose } from "react-icons/io";
import CheckboxIcon from "../../assets/images/CheckboxWhite.svg";
import CheckboxBlueIcon from "../../assets/images/CheckboxBlue.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  AddItemInExistingOrder,
  FetchProductBysupplierid,
  FetchPurchasingOrder,
} from "../../redux/actions/action";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Image } from "react-bootstrap";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";

const AddMissingItems = ({
  setOpenAddItem,
  openAddItem,
  suppliersId,
  setAddMissingItems,
  addMissingItems,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const orderId = location.state.orderid;
  const fetchProductBySupplierIdList = useSelector(
    (state) => state.user.fetchProductBySupplierId,
  );
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);
  const [searchItems, setSearchItems] = useState("");
  const [stockData, setStockData] = useState([]);

  useEffect(() => {
    if (suppliersId) {
      dispatch(FetchProductBysupplierid(suppliersId));
    }
  }, [dispatch, suppliersId]);

  useEffect(() => {
    if (
      fetchProductBySupplierIdList != null &&
      fetchProductBySupplierIdList?.status
    ) {
      setStockData(fetchProductBySupplierIdList?.data);
    }
  }, [fetchProductBySupplierIdList]);

  const handleCheckboxChange = (productPartid) => {
    const updatedData = stockData.map((item) =>
      item.productPartid === productPartid
        ? { ...item, isChecked: !item.isChecked }
        : item,
    );
    setStockData(updatedData);
  };
  const handleSearchInputChange = (e) => {
    setSearchItems(e.target.value);
    searchItemFun();
  };
  const searchItemFun = () => {
    const result = stockData.filter((item) =>
      item.productpartname.toLowerCase().includes(searchItems.toLowerCase()),
    );
    setStockData(result);
  };
  const AddMissingItems = () => {
    const orderProductsData = stockData
      ?.filter((val) => val.isChecked)
      .map((item) => ({
        productid: item.productPartid,
        orderproductqty: "0",
      }));
    const payload = {
      orderid: orderId,
      orderproducts: orderProductsData,
    };
    dispatch(AddItemInExistingOrder(payload));
    setOpenAddItem(!openAddItem);
    setAddMissingItems(!addMissingItems);
    setTimeout(() => {
      dispatch(FetchPurchasingOrder(orderId));
    }, 2000);
  };
  return (
    <div className="add-item-wrapper">
      <div className="d-flex justify-content-between align-items-center bgdiv">
        <p className="inputparts px-3">Parts</p>
        <div className="add-item-title w-100">
          <input
            className="update-member-input-noborder add-member-input bgforinput w-100"
            value={searchItems}
            onChange={handleSearchInputChange}
            placeholder="Search ... "
          />
        </div>

        <img
          src={DelIcon}
          alt=""
          className="mx-3 cursor-pointer"
          onClick={() => setOpenAddItem(!openAddItem)}
        />
      </div>
      <div className="border-line d-none"></div>
      <div className="stock-items-main gap-0 p-3">
        {stockData.map((item, index) => (
          <div
            key={index}
            className="missing-items add-item-title pointer"
            onClick={() => handleCheckboxChange(item.productPartid)}
          >
            <img
              // onClick={() => handleCheckboxChange(item.productPartid)}
              className="plus-img"
              src={item.isChecked ? CheckboxBlueIcon : CheckboxIcon}
              alt="check-item"
            />

            <div className="count-title">{item.productpartname}</div>

            {isBuildingBlock && (
              <div className="title-hover">
                <div className="items-desc-column1">
                  <div className="desc-image-wrp1 desc-image1 ">
                    {item.cover ? (
                      <>
                        <div
                          className={`product-list-image-default1 ${
                            item.image.length === 0 ? "hover-hide1" : ""
                          }`}
                        >
                          <img
                            src={item.cover}
                            alt=""
                            className="cover-image1"
                          />
                          {item.image && item.image.length > 0 && (
                            <div className="image-row1">
                              {item.image.slice(0, 3).map((val, index) => (
                                <img
                                  key={index}
                                  src={val}
                                  alt={`Images ${index + 1}`}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                        {item.image && item.image.length > 0 && (
                          <span className="desc-image-plus1">
                            <Image
                              height={10}
                              width={10}
                              src={plusBorderWhite}
                            />
                          </span>
                        )}
                      </>
                    ) : (
                      <div className="product-list-default1">
                        <img src={Package} alt="" className="default-img1" />
                        <div className="product-image-title d-none">
                          Picture
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="missing-items-wrapper" style={{ width: "160px" }}>
              <div className="stock-wrp">
                <div>Stock</div>
              </div>
              <div className="stock-items">
                <div className="d-flex align-items-center gap-3 justify-content-center">
                  {/* {items.stockItem.length > 0 ? (
                                        items.stockItem.map((info, ind) => ( */}
                  <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                    <div
                      style={{ backgroundColor: `${item.color}` }}
                      className="color-code"
                    ></div>
                  </div>
                  <div className="info-items">{item.instock}</div>
                  {/* ))
                                    ) : (
                                        <div className="empty-item">-</div>
                                    )} */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="add-button-wrapper">
        <button
          type="button"
          className="btn add-button add-btn-disable"
          onClick={AddMissingItems}
          disabled={!stockData.some((val) => val.isChecked === true)}
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default AddMissingItems;
